import React from 'react';
import {changeCurrency} from "../actions";
import {connect} from "react-redux";
import Currency from "./../component/Currency";
import {getCurrencies, getSelectedCurrency, getCurrencySymbols} from "../reducers";

const mapStateToProps = state => {
    return {
        currencies: getCurrencies(state),
        selectedCurrency: getSelectedCurrency(state),
        currencySymbols: getCurrencySymbols(state),
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onChange: event => {
            dispatch(changeCurrency(event.target.value))
        },
    }
}

const CurrencyContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Currency)

export default CurrencyContainer
